import styled from '@emotion/styled';
import { rem } from '@utils';

const Root = styled.article`
  background: ${({ theme }) => theme.palette.common.white};
  border: ${rem(1)} solid ${({ theme }) => theme.palette.grey['200']};
  border-radius: ${rem(8)};
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
  padding: ${rem(16)};
  width: 100%;
`;

const Body = styled.p`
  color: ${({ theme }) => theme.palette.common.black};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${rem(20)};
  font-weight: 400;
  line-height: ${rem(32)};
  margin: 0;
`;

const Emphasis = styled.strong`
  font-weight: 600;
`;

export default {
  Root,
  Body,
  Emphasis
};
